module.exports = "https://bin.bnbstatic.com/_next/static/images/ecosystem2x-907276ee5bf1cc242173a630056d3ee9.png";